const options = [
  { label: "01 al 05 de cada mes", value: "1", min: 1, max: 5 },
  { label: "15 al 20 de cada mes", value: "15", min: 15, max: 20 },
  { label: "25 al 30 de cada mes", value: "25", min: 25, max: 30 },
];

export default options;
